const product_variable_urls = document.querySelectorAll('.productView .prd_col_wpr li');
const cur_url = window.location.href;


if(product_variable_urls){
  product_variable_urls.forEach((li)=>{
    if(li.dataset.prdUrl == cur_url ){      
      li.classList.add('active')
    }else{
      li.classList.remove('active')
    }
  })
}



class faqBlock extends HTMLElement {
    constructor() {
      super();
    }
    connectedCallback() {
      const qus = this.querySelector('.faq-question');
      const ans = this.querySelector('.faq-answer');
  
      qus.addEventListener('click', () => {
        this.classList.toggle('active');
        if (this.classList.contains('active')) {
          ans.style.maxHeight = ans.scrollHeight + 'px';
        } else {
          ans.style.maxHeight = null;
        } 
      });
    }
  }
  customElements.define('faq-block', faqBlock);


    let prd_media_elm = document.querySelector('.mobile_view_gallery')
    if(prd_media_elm){
          const prd_media_splide = new Splide(prd_media_elm, {
        type: 'slide',
        pagination: false,
        padding: { left: 13, right: 100 },
            gap:'15px',
        breakpoints: {
        },
      });

      const bar = prd_media_splide.root.querySelector('.my-slider-progress-bar');

      if (bar) {
        prd_media_splide.on('mounted move', function () {
          const end = prd_media_splide.Components.Controller.getEnd() + 1;
          const rate = Math.min((prd_media_splide.index + 1) / end, 1);
          bar.style.width = `${100 * rate}%`;
        });
      }

      prd_media_splide.mount();
    }

